module.exports = __webpack_public_path__ + "static/media/icon-facebook.d52cdb37.svg";